<template>
    <el-dialog
        v-model="edit_info"
        title="找回密码"
        width="800px"
        align-center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
        <div style="margin: 0 auto;width: 80%;">
            <el-form :model="form">
                <div style="margin-bottom: 15px;">
                    <el-input v-model="form.phone" placeholder="手机号">
                        <template #prepend>
                            <div style="width: 80px;">手机号</div>
                        </template>
                    </el-input>
                </div>
                <div style="display: flex;align-content: center;margin-bottom: 15px;">
                    <el-input v-model="form.code" placeholder="验证码" style="margin-right: 20px;">
                        <template #prepend>
                            <div style="width: 80px;">验证码</div>
                        </template>
                    </el-input>
                    <el-button
                        :disabled="user_entity_disabled_click"
                        @click="get_user_entity_phone_code"
                        type="warning"
                        style="width: 110px;text-align: center;margin: 0 auto;"
                    >
                        {{ user_entity_btn_txt }}
                    </el-button>
                </div>
                <div style="margin-bottom: 15px;">
                    <el-input v-model="form.new_password" type="password" show-password placeholder="密码">
                        <template #prepend>
                            <div style="width: 80px;">密码</div>
                        </template>
                    </el-input>
                </div>
                <div>
                    <el-input v-model="form.verify_password" type="password" show-password placeholder="确认密码">
                        <template #prepend>
                            <div style="width: 80px;">确认密码</div>
                        </template>
                    </el-input>
                </div>
            </el-form>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="edit_info = 0">取消</el-button>
                <el-button type="primary" @click="submit">
                  提交
                </el-button>
                </span>
        </template>
    </el-dialog>
</template>

<script>
import api from '@/api'
import axios from "axios";
import {ElMessageBox, ElMessage, ElNotification} from 'element-plus'

export default {
    name: 'ForgetPassword',
    props: {
        show: Number,
        fatherMethod: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            edit_info: false,
            form: {
                phone: '',
                code: '',
                new_password: '',
                verify_password: '',
            },
            user_entity_btn_txt: '发送验证码',
            user_entity_disabled_click: false,
            user_entity_phone_time: 60,
        }
    },
    watch: {
        show(new_val) {
            this.edit_info = new_val > 0;
        }
    },
    methods: {
        submit(e) {

            let reg_phone = /^1\d{10}$/;
            if (reg_phone.test(this.form.phone) === false) {
                ElNotification({title: '友情提醒', message: '手机号输入有误', type: 'warning',})
                return false;
            }

            let reg_code = /^\d{6}$/;
            if (reg_code.test(this.form.code) === false) {
                ElNotification({title: '友情提醒', message: '验证码输入有误', type: 'warning',})
                return false;
            }

            if (this.form.verify_password.length < 6 || this.form.verify_password.length > 20 || this.form.new_password.length < 6 || this.form.new_password.length > 20) {
                this.user_entity_disabled_click = false;
                ElNotification({title: '友情提醒', message: '密码必须:大于6位,小于20位', type: 'warning',})
                return false;
            }

            if (this.form.verify_password !== this.form.new_password) {
                this.user_entity_disabled_click = false;
                ElNotification({title: '友情提醒', message: '两次密码输入有误', type: 'warning',})
                return false;
            }

            this.edit_info = 0
            this.$emit('fatherMethod', this.form);
        },
        get_user_entity_phone_code() {
            this.user_entity_disabled_click = true;
            let reg = /^1\d{10}$/;
            //console.log(reg.test(this.form.phone))
            if (reg.test(this.form.phone) === false) {
                this.user_entity_disabled_click = false;
                ElNotification({title: '友情提醒', message: '手机号输入有误', type: 'warning',})
                return false;
            }

            let that = this
            axios.post(
                api.user.send_phone_code_by_forget_pass, {'phone': this.form.phone}
            ).then(function (res) {
                //console.log(res.data.data)
                if (res.data.code === 10000) {
                    that.user_entity_phone_timers()
                } else {
                    that.user_entity_disabled_click = false;
                    ElNotification({title: '友情提醒', message: res.data.data.msg, type: 'warning',})
                }
            }).catch(function (err) {
                that.user_entity_disabled_click = false;
                that.$notify.error({title: '错误', message: err.response.data.msg});
            });

            that.user_entity_phone_timers()
        },
        user_entity_phone_timers() {
            if (this.user_entity_phone_time > 0) {
                this.user_entity_disabled_click = true;
                this.user_entity_phone_time--;
                this.user_entity_btn_txt = this.user_entity_phone_time + " 秒";
                setTimeout(this.user_entity_phone_timers, 1000);
            } else {
                this.user_entity_phone_time = 60;
                this.user_entity_btn_txt = "发送验证码";
                this.user_entity_disabled_click = false;
            }
        },
    }
}
</script>